import { Link } from "react-router-dom";
import { Home, Instagram, Facebook, Mail, MessageCircle, Phone, MapPin } from "lucide-react";
import { usePublicSiteCms } from "@/lib/siteCms";

export default function Footer() {
  const cms = usePublicSiteCms();
  const b = cms?.branding || {};
  const brand = b.brand_name || "AVASA";
  const cols = [
    { title: "Produk", links: [
      { label: "Cari Hunian", to: "/search" },
      { label: "Kos", to: "/search" },
      { label: "Apartemen", to: "/search" },
      { label: "Co-living", to: "/search" },
    ] },
    { title: "Perusahaan", links: [
      { label: "Tentang AVASA", to: "/tentang-kami", testid: "footer-about-link" },
      { label: "Hubungi Kami", to: "/hubungi-kami", testid: "footer-contact-link" },
      { label: "Master Lokasi", to: "/location-demo", testid: "footer-location-link" },
    ] },
    { title: "Bantuan", links: [
      { label: "Syarat & Ketentuan", to: "/syarat-ketentuan", testid: "footer-terms-link" },
      { label: "Kebijakan Privasi", to: "/kebijakan-privasi", testid: "footer-privacy-link" },
      { label: "Hubungi Kami", to: "/hubungi-kami" },
    ] },
  ];

  return (
    <footer className="bg-primary text-primary-foreground mt-auto" data-testid="main-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-10">
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              {b.logo_url ? (
                <img src={b.logo_url} alt={brand} className="w-9 h-9 rounded-xl object-cover" />
              ) : (
                <span className="grid place-items-center w-9 h-9 rounded-xl bg-primary-foreground/10"><Home size={18} /></span>
              )}
              <span className="font-heading text-xl font-bold" data-testid="footer-brand">{brand}</span>
            </div>
            <p className="text-sm text-primary-foreground/70 leading-relaxed max-w-xs" data-testid="footer-text">
              {b.footer_text || "Marketplace hunian di Indonesia. Temukan kos, apartemen, dan hunian sewa berdasarkan lokasi, harga, dan fasilitas."}
            </p>
            <div className="mt-4 space-y-1.5 text-sm text-primary-foreground/75">
              {b.contact_address && <p className="flex items-start gap-2" data-testid="footer-address"><MapPin size={15} className="mt-0.5 shrink-0" /><span>{b.contact_address}</span></p>}
              {b.contact_phone && <a href={`tel:${String(b.contact_phone).replace(/\s/g, "")}`} className="flex items-center gap-2 hover:text-primary-foreground" data-testid="footer-phone"><Phone size={15} className="shrink-0" /><span>{b.contact_phone}</span></a>}
              {b.contact_email && <a href={`mailto:${b.contact_email}`} className="flex items-center gap-2 hover:text-primary-foreground" data-testid="footer-email-text"><Mail size={15} className="shrink-0" /><span>{b.contact_email}</span></a>}
            </div>
            <div className="flex items-center gap-3 mt-4">
              {b.instagram && <a href={b.instagram.startsWith("http") ? b.instagram : `https://instagram.com/${b.instagram.replace("@", "")}`} target="_blank" rel="noreferrer" data-testid="footer-instagram" className="grid place-items-center w-9 h-9 rounded-full bg-primary-foreground/10 hover:bg-primary-foreground/20 transition-colors"><Instagram size={16} /></a>}
              {b.facebook && <a href={b.facebook.startsWith("http") ? b.facebook : `https://facebook.com/${b.facebook}`} target="_blank" rel="noreferrer" data-testid="footer-facebook" className="grid place-items-center w-9 h-9 rounded-full bg-primary-foreground/10 hover:bg-primary-foreground/20 transition-colors"><Facebook size={16} /></a>}
              {b.contact_email && <a href={`mailto:${b.contact_email}`} data-testid="footer-email" className="grid place-items-center w-9 h-9 rounded-full bg-primary-foreground/10 hover:bg-primary-foreground/20 transition-colors"><Mail size={16} /></a>}
              {b.contact_whatsapp && <a href={`https://wa.me/${String(b.contact_whatsapp).replace(/[^0-9]/g, "").replace(/^0/, "62")}`} target="_blank" rel="noreferrer" data-testid="footer-whatsapp" className="grid place-items-center w-9 h-9 rounded-full bg-primary-foreground/10 hover:bg-primary-foreground/20 transition-colors"><MessageCircle size={16} /></a>}
            </div>
          </div>
          {cols.map((col) => (
            <div key={col.title}>
              <h4 className="font-heading font-semibold mb-4 text-sm uppercase tracking-widest text-primary-foreground/60">
                {col.title}
              </h4>
              <ul className="space-y-3">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <Link
                      to={l.to}
                      data-testid={l.testid}
                      className="text-sm text-primary-foreground/80 hover:text-primary-foreground transition-colors"
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-12 pt-8 border-t border-primary-foreground/15 text-sm text-primary-foreground/60">
          © {new Date().getFullYear()} {brand}. Seluruh hak cipta dilindungi.
        </div>
      </div>
    </footer>
  );
}
